// Nosotros es el único que no es un ancla del scroll: tiene página propia.
const navItems = [
  { label: 'Nosotros', target: 'nosotros', href: '/nosotros' },
  { label: 'Servicios', target: 'servicios', href: '#servicios' },
  { label: 'Conocimiento', target: 'conocimiento', href: '#conocimiento' },
];

export default function Footer({ onNavigate }) {
  return (
    <footer className="w-full bg-[#0a0e14]">
      {/* Top section with logo */}
      <div className="border-b border-[#C9A26E]/10">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-16 md:py-20">
          <img
            src="/assets/todd-logo.png"
            alt="Todd Empresas de Familia"
            className="h-10 md:h-12 mb-6 opacity-80"
          />
          <p className="font-body text-[#5a544c] text-sm tracking-wide">
            Legal Roots. Strategic Oversight. Family Continuity.
          </p>
        </div>
      </div>

      {/* Main footer content */}
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Navigation */}
          <div>
            <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-[#C9A26E]/60 mb-6">
              Navegación
            </span>
            <nav className="flex flex-col gap-3">
              {navItems.map((item) => (
                <a
                  key={item.target}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); onNavigate(item.target); }}
                  className="font-body text-sm text-[#7a7468] hover:text-[#C9A26E] transition-colors duration-300"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Monterrey */}
          <div>
            <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-[#C9A26E]/60 mb-6">
              Oficina Monterrey
            </span>
            <address className="not-italic font-body text-sm text-[#7a7468] leading-[1.9]">
              Batallón de San Patricio 111, Piso 26<br />
              Torre ING, Col. Valle Oriente<br />
              San Pedro Garza García, N.L.<br />
              CP 66269
            </address>
            <a
              href="mailto:todd@empresasdefamilia.mx"
              className="block mt-4 font-body text-sm text-[#C9A26E] hover:text-[#d4b07e] transition-colors duration-300"
            >
              todd@empresasdefamilia.mx
            </a>
          </div>

          {/* Laguna */}
          <div>
            <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-[#C9A26E]/60 mb-6">
              Oficina Laguna
            </span>
            <address className="not-italic font-body text-sm text-[#7a7468] leading-[1.9]">
              Av. Juan Terrazas 513<br />
              Ampliación los Ángeles<br />
              Torreón, Coahuila<br />
              CP 27148
            </address>
            <a
              href="mailto:todd@empresasdefamilia.mx"
              className="block mt-4 font-body text-sm text-[#C9A26E] hover:text-[#d4b07e] transition-colors duration-300"
            >
              todd@empresasdefamilia.mx
            </a>
          </div>

          {/* Tagline */}
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-[#C9A26E]/60 mb-6">
              Filosofía
            </span>
            <p className="font-heading text-[#8a8075] text-lg leading-[1.6] italic">
              &ldquo;El legado familiar no se improvisa.&rdquo;
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#C9A26E]/8">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="font-mono text-[10px] tracking-[0.1em] text-[#5a544c]">
            © 2026 Todd Empresas de Familia, SC
          </span>
          <div className="flex gap-6">
            {/* La referencia deja estos dos enlaces en "#". El de privacidad sí
                tiene destino real en producción y se conserva. */}
            <a
              href="/politica-privacidad.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-[10px] tracking-[0.1em] text-[#5a544c] hover:text-[#C9A26E] transition-colors duration-300"
            >
              Privacidad
            </a>
            {/* En la referencia "Legal" es un enlace a "#", es decir a ninguna
                parte. No se finge un destino que no existe: mismo aspecto, sin
                fingir que es navegable. */}
            <span className="font-mono text-[10px] tracking-[0.1em] text-[#5a544c] hover:text-[#C9A26E] transition-colors duration-300">
              Legal
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
